import React, { useState, useEffect } from "react";
import colors from "../constants/colors";
import axios from "axios";
import studentId from "../config";
import {fetchSchoolData, getPhone1, getPhone2  } from "../Schoolinfo.js";
const Support = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [schoolPhone, setSchoolPhone] = useState("");
  const [teacherContact, setTeacherContact] = useState({
    fullName: [],
    phone: [],
    email: [],
    found: false,
  });
  const [loading, setLoading] = useState(true);
useEffect(() => {
  const loadSchoolPhone = async () => {
    try {
      await fetchSchoolData();
      const phone = getPhone1() || getPhone2();
      setSchoolPhone(phone);
    } catch (err) {
      console.error("Failed to load school phone", err);
    }
  };

  loadSchoolPhone();
}, []);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchTeacherContacts = async () => {
      try {
        setLoading(true);
        const sessionId = localStorage.getItem("currentSessionId");

        // 1. Fetch student details
        const studentRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`,
          { params: { sessionId } }
        );
        const studentData = studentRes.data;
        const studentClassSection = `${studentData.class} - ${studentData.section}`;

        // 2. Fetch all teachers
        const teacherRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers`,
          { params: { sessionId } }
        );

        const teachersArray = Array.isArray(teacherRes.data)
          ? teacherRes.data
          : [teacherRes.data];

        // 3. Find teacher(s) for this student's class-section
        const matchingTeachers = teachersArray.filter(
          (t) => t.classIncharge === studentClassSection
        );

        if (matchingTeachers.length > 0) {
          const phones = matchingTeachers.flatMap((t) =>
            [t.phoneNo, t.phoneNo2].filter(Boolean)
          );
          const emails = matchingTeachers.map((t) => t.email).filter(Boolean);
          const fullNames = matchingTeachers.map(
            (t) => `${t.firstName} ${t.lastName}`
          );

          setTeacherContact({
            fullName: fullNames,
            phone: phones,
            email: emails,
            found: true,
          });
        } else {
          setTeacherContact({ fullName: [], phone: [], email: [], found: false });
        }
      } catch (error) {
        console.error("Error fetching teachers:", error);
        setTeacherContact({ fullName: [], phone: [], email: [], found: false });
      } finally {
        setLoading(false);
      }
    };

    fetchTeacherContacts();
  }, []);

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const cardStyle = {
    background: "#ffffff",
    padding: "16px",
    borderRadius: "12px",
    boxShadow: `0 2px 8px ${colors.cardShadow}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    transition: "0.3s",
  };

  const heading = {
    fontSize: "16px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const iconStyle = {
    fontSize: "24px",
    marginBottom: "8px",
  };

  const cards = [
    {
      label: "School Helpline",
      icon: "fa-phone",
      color: colors.primary,
      text: "Contact numbers for school support.",
       list: schoolPhone
    ? [
        <a
          key="school-phone"
          href={`tel:${schoolPhone.replace(/\D/g, "")}`}
          className="text-blue-600 hover:underline"
        >
          📞 {schoolPhone}
        </a>,
      ]
    : ["Helpline number not available"],
    },
    {
      label: "Class Teacher Contact",
      icon: "fa-user-tie",
      color: colors.secondary,
      text: "Contact details of class teachers.",
      list: teacherContact.found
        ? teacherContact.fullName.map((name, idx) => (
            <div key={name}>
              <strong>{name}</strong>
              {teacherContact.phone[idx] && (
                <div>
                  Phone:{" "}
                  <a
                    href={`tel:${teacherContact.phone[idx]}`}
                    className="text-blue-600 hover:underline"
                  >
                    {teacherContact.phone[idx]}
                  </a>
                </div>
              )}
              {teacherContact.email[idx] && (
                <div>
                  Email:{" "}
                  <a
                    href={`mailto:${teacherContact.email[idx]}`}
                    className="text-blue-600 hover:underline"
                  >
                    {teacherContact.email[idx]}
                  </a>
                </div>
              )}
            </div>
          ))
        : ["No teacher found for your class"],
    },
    {
      label: "Important Numbers (India)",
      icon: "fa-exclamation-circle",
      color: "#FF3B30",
      text: "Emergency contact numbers.",
      list: ["Child Helpline: 1098", "Police: 100", "Fire: 101"],
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
   

        {loading ? (
          <div className="text-center text-gray-500">Loading...</div>
        ) : (
          <div
            className={`grid gap-6 ${
              isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"
            }`}
          >
            {cards.map((card, idx) => (
              <div
                key={idx}
                style={cardStyle}
                className="hover:scale-[1.02] transition cursor-pointer"
              >
                <i
                  className={`fas ${card.icon}`}
                  style={{ ...iconStyle, color: card.color }}
                ></i>
                <h2 style={heading}>{card.label}</h2>
                <p style={subText}>{card.text}</p>
                <ul className="list-disc ml-5 mt-2" style={subText}>
                  {card.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Support;
